import { gql } from "@apollo/client";

export default gql`
  mutation allowToPostPrivateJob($data: AllowPrivateJobInput!) {
    allowToPostPrivateJob(data: $data) {
      id
    }
  }
`;
